export enum FeatureFlags {
    networkAnalytics = 'monitoring.network-metrics',
    structSubscription = 'retail.offer-display.live.struct-subscription',
    networkRetries = 'retail.offer-display.live.network-retries',
    offerClientErrorLogging = 'retail.offer-display.live.offer-client-error-logging',
    threeDecimalPoints = 'retail.odd-3-decimal-places',
    offerV3 = 'retail.offer-display.live.offer-v3'
}

export const FeatureFlagsDefaultValues = {
    [FeatureFlags.networkAnalytics]: false,
    [FeatureFlags.structSubscription]: true,
    [FeatureFlags.networkRetries]: true,
    [FeatureFlags.offerClientErrorLogging]: true,
    [FeatureFlags.threeDecimalPoints]: false,
    [FeatureFlags.offerV3]: false
};
